// extracted by mini-css-extract-plugin
export default {"alignment":"uxvwEs","dateLocation":"b6Z9By"};